(() => {
  const initContactCenter = (root) => {
    if (!root || root.dataset.contactCenterReady === 'true') return;
    root.dataset.contactCenterReady = 'true';

    const form = root.querySelector('form.tan-contact-center__form');
    const formCard = root.querySelector('[data-contact-form-card]');
    const topicSelect = root.querySelector('[data-contact-topic]');
    const topicHint = root.querySelector('.tan-contact-center__field-hint[data-topic-hint]');
    const topicLabel = root.querySelector('[data-topic-label]');
    const entryRoute = root.querySelector('[data-entry-route]');
    const browserPage = root.querySelector('[data-browser-page]');
    const conditionalFields = [...root.querySelectorAll('[data-conditional-field]')];
    const success = root.querySelector('[data-contact-success]');

    const setConditionalField = (field, visible) => {
      field.hidden = !visible;
      field.querySelectorAll('input, select, textarea').forEach((input) => {
        input.disabled = !visible;
        if (input.hasAttribute('data-required-when-visible')) input.required = visible;
      });
    };

    const updateTopic = () => {
      if (!(topicSelect instanceof HTMLSelectElement)) return;

      const option = topicSelect.selectedOptions[0];
      const topicKey = option?.value || '';
      const needsOrder = option?.dataset.needsOrder === 'true';
      const needsMedia = option?.dataset.needsMedia === 'true';

      conditionalFields.forEach((field) => {
        const type = field.dataset.conditionalField;
        setConditionalField(field, type === 'order' ? needsOrder : type === 'media' ? needsMedia : false);
      });

      if (topicHint) topicHint.textContent = option?.dataset.topicHint || topicHint.dataset.defaultHint || topicHint.textContent;
      if (topicLabel) topicLabel.value = option?.dataset.topicLabel || option?.textContent?.trim() || '';
      root.dataset.activeTopic = topicKey;
    };

    if (topicHint) topicHint.dataset.defaultHint = topicHint.textContent;
    if (browserPage) browserPage.value = window.location.href;

    if (topicSelect instanceof HTMLSelectElement) {
      const params = new URLSearchParams(window.location.search);
      const requestedTopic = (params.get('topic') || '').trim().toLowerCase();
      const requestedOrder = (params.get('order') || '').trim();
      const matchingOption = [...topicSelect.options].find((option) => option.value === requestedTopic);

      if (matchingOption) topicSelect.value = matchingOption.value;
      updateTopic();
      topicSelect.addEventListener('change', updateTopic);

      if (requestedOrder) {
        const orderInput = root.querySelector('[name="contact[Order number]"]');
        if (orderInput && !orderInput.disabled) orderInput.value = requestedOrder;
      }
    }

    root.querySelectorAll('[data-contact-route]').forEach((route) => {
      route.addEventListener('click', (event) => {
        const topicKey = (route.dataset.topicKey || '').trim().toLowerCase();

        if (topicSelect instanceof HTMLSelectElement && topicKey) {
          const matchingOption = [...topicSelect.options].find((option) => option.value === topicKey);
          if (matchingOption) {
            topicSelect.value = matchingOption.value;
            updateTopic();
          }
        }

        if (entryRoute) entryRoute.value = route.dataset.topicKey || 'Contact route card';
        if (formCard) {
          event.preventDefault();
          formCard.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => topicSelect?.focus({ preventScroll: true }), 450);
        }
      });
    });

    form?.addEventListener('submit', () => {
      updateTopic();
      if (browserPage) browserPage.value = window.location.href;
    });

    if (success) {
      window.requestAnimationFrame(() => success.focus({ preventScroll: true }));
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-tan-contact-center]').forEach(initContactCenter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
